import $ from "jquery";
// import { notify } from '../notification/notification';
// import { closeSections } from '../navbar-section/navbar-section';

export function initContactForm() {
  $(function () {
    const resultMsg = $("#contactFormResult");
    $(".contact-form").on("submit", function (e) {
      resultMsg.html("");
      resultMsg.removeClass("alert alert-danger alert-success");
      const thisForm = this as HTMLFormElement;
      const form = $(thisForm).serialize();
      const url = thisForm.action;
      $.ajax({
        url: url,
        type: "POST",
        data: form,
        success: (data, _status) => {
          thisForm.reset();
          resultMsg.html(data);
          resultMsg.addClass("alert alert-success");
        },
        error: (jqXHR, _status, _error) => {
          resultMsg.html(jqXHR.responseText);
          resultMsg.addClass("alert alert-danger");
        },
      });

      e.preventDefault();
    });
  });
}
